import styled from 'styled-components';
import { IconButton } from 'ui/button';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { colors, heading4, largeShadow, spacing, body1, borderRadius } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const CampaignStepCardWrapper = styled.div<{
  $isEditable?: boolean;
  $isTemplateContent?: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: ${({ $isTemplateContent }) => `${$isTemplateContent ? '0' : spacing.plusHalf}`};
  border-radius: 8px;
  outline: ${({ $isEditable }) =>
    $isEditable
      ? `${spacing.eighth} solid ${colors.green50}`
      : `${spacing.single} solid ${colors.grey15}`};
  ${({ $isEditable }) => ($isEditable ? largeShadow : ``)}
`;

export const CampaignCardWrapper = styled(CampaignStepCardWrapper)`
  background: ${colors.grey1};
`;

export const StyledOverflowButton = styled(IconButton)`
  margin-right: -${spacing.single};
  border-radius: 0 ${borderRadius.md} ${borderRadius.md} 0;
`;

export const CampaignCardHeader = styled.div<{
  $isTemplateContent?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${pxToRem(5)};
  align-items: center;
  padding: ${({ $isTemplateContent }) =>
    `${
      $isTemplateContent ? `${spacing.plusHalf} ${spacing.plusHalf} 0 ${spacing.plusHalf}` : '0'
    }`};
`;

export const CampaignCardHeaderTitleWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const CampaignStepCardHeaderTitle = styled(CampaignCardHeaderTitleWrapper)`
  cursor: pointer;
  align-items: center;
`;

export const CampaignCardTitle = styled.h2`
  ${heading4};
  margin-top: 0;
  margin-bottom: 0;
`;

export const CampaignCardTitleDetail = styled.span`
  ${body1}
  margin-left: ${spacing.quarter};
  color: ${colors.secondaryText};
`;

export const ComboButton = styled.div`
  column-gap: none;
  display: flex;
  > button:first-child {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-right: none;
  }
  > *:last-child > button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`;

export const SummaryContentWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${pxToRem(581)};
`;

export const FullWidthCollapsibleContent = styled(CollapsibleContent)`
  width: 100%;
`;
